import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { createWarehouseWithAssociations, deleteShipperWithAssosciation, deleteWarehouseWithAsssociation, getWarehousesWithAssociation, updateWarehouseWithAssociation } from 'utils/UserWebAPIUtils';

export function useCreateWarehouseWithAssociations(onSaveSuccess, onSaveFail) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: createWarehouseWithAssociations,
    onSuccess: async (data) => {
      await queryClient.refetchQueries('warehouses-association');
      if (onSaveSuccess) {
        onSaveSuccess(data);
      }
    },
    onError: (error) => {
      if (onSaveFail) {
        onSaveFail(error);
      }
    },
  });

  return { mutation };

}

export function useWarehousesWithAssociation() {
  const query = useQuery({
    queryKey:['warehouses-association'],
    queryFn: getWarehousesWithAssociation,
    staleTime:Infinity,
  });


  const { data, error, isLoading, isError, isSuccess, status, isRefetching, refetch } =
    query;

  return { data, error, isLoading, isError, isSuccess, status, isRefetching, refetch }
}

export function useDeleteWarehouseWithAsssociation(onDeleteSuccess, onDeleteFail) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: deleteWarehouseWithAsssociation,
    onSuccess: async (data) => {
      await queryClient.refetchQueries('warehouse-association');
      if(onDeleteSuccess) {
        onDeleteSuccess(data);
      }

    },
    onError: async (err) => {
      if(onDeleteFail) {
        onDeleteFail(err);
      }

    }
  });

  return {mutation}

}


export function useDeleteShipperWithAssociation(onDeleteSuccess, onDeleteFail) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: deleteShipperWithAssosciation,
    onSuccess: async (data) => {
      await queryClient.refetchQueries('warehouse-association');
      if (onDeleteSuccess) {
        onDeleteSuccess(data);
      }

    },
    onError: async (err) => {
      if (onDeleteFail) {
        onDeleteFail(err);
      }

    }
  });

  return { mutation }

}


